import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ComisionDispositionResume } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { ModalCommissionDispositionComponent } from 'src/oldApp/shared/modal-commission-disposition/modal-commission-disposition.component';
import { PagoDistribuidor } from '../../pagos-distribuidor/pagos-distribuidor.component';

@Component({
  selector: 'app-comisiones-retenciones',
  templateUrl: './comisiones-retenciones.component.html',
  styleUrls: ['./comisiones-retenciones.component.css']
})
export class ComisionesRetencionesComponent implements OnInit {

  public view = 0;
  loading: boolean = true;
  listComisionDispositionDetail: any[] = [];
  displayedColumns: string[] = [
    'fechaEjecucion',
    'fechaCobro',
    'periodoInicio',
    'periodoFin',
    'session',
    'montoComisiones',
    'colocacion',
    'status',
    'ver'
  ];
  dataSource: MatTableDataSource<PagoDistribuidor>;
  searchField: string = 'fechaEjecucion';
  role: string = '';

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  public userId = Number(localStorage.getItem('com_token'));
  constructor(private commissionSalePromotionsService: CommissionSalePromotionsService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.dataSource = new MatTableDataSource<PagoDistribuidor>([]);
  }

  ngOnInit() {
    this.GetCommissionDisposition();
    this.view = 1;
  }

  ngAfterViewInit() {
    this.setupCustomFilter();
  }

  setupCustomFilter() {
    this.dataSource.filterPredicate = (data: PagoDistribuidor, filter: string) => {
      const searchStr = filter.trim().toLowerCase();

      if (this.searchField === 'fechaEjecucion') {
        return data.fechaEjecucion.toLowerCase().includes(searchStr);
      } else if (this.searchField === 'fechaCobro') {
        return data.fechaCobro.toLowerCase().includes(searchStr);
      }

      return false;
    };
  }

  onSearchFieldChange() {
    console.log('Campo de búsqueda cambiado a:', this.searchField);
    // Reconfigura el filtro y reaplica la búsqueda actual
    this.setupCustomFilter();
    if (this.dataSource.filter) {
      this.dataSource.filter = this.dataSource.filter;
    }
  }

  GetCommissionDisposition() {
    this.loading = true;
    this.commissionSalePromotionsService.GetCommissionDispositionResume()
      .pipe(
        map((resp: any) => {
          // Transformar cada item del response al formato PagoDistribuidor
          return resp.data.map((item: ComisionDispositionResume) => ({

            fechaEjecucion: item.fechaEjecucion || '',
            fechaCobro: item.FechaCobro || '',
            periodoInicio: this.formatDateTime(item.fechaInicio),
            periodoFin: this.formatDateTime(item.fechaFin),
            session: item.sessionId || '',
            montoComisiones: item.montoTotal || 0,
            colocacion: item.Colocacion || 0,
            status: item.enviado == 0 ? 'NO ENVIADO' : item.enviado == 1 ? 'ENVIADO' : 'INCOMPLETO'
          } as PagoDistribuidor));
        }),
        tap((pagos: PagoDistribuidor[]) => {
          this.dataSource.data = pagos;
          this.loading = false;

          setTimeout(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.setupCustomFilter();
          });
        }),
        catchError((error) => {
          this.loading = false;
          this.toastr.error('Ocurrió un error al leer el resumen de archivos de envío a pago.');
          return of([]);
        })
      )
      .subscribe();
  }

  formatDateTime(value: string | null): string {
    if (!value) return '';
    const d = new Date(value);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  GetCommissionDispositionDetail(fechaCobroInicio: string, fechaCobroFin: string, fechaCobro: string, fechaEjecucion: string, sessionId: string, enviado: number) {
    this.commissionSalePromotionsService.GetCommissionDispositionDetail({
      fechaCobroInicio: fechaCobroInicio,
      fechaCobroFin: fechaCobroFin,
      fechaCobro: fechaCobro,
      fechaEjecucion: fechaEjecucion,
      sessionId: sessionId,
      userId: this.userId
    }).pipe(
      tap((resp: any) => {
        this.listComisionDispositionDetail = resp.data;
        this.listComisionDispositionDetail.forEach(item => {
          item.fechaInicio = this.formatDateTime(item.fechaInicio);
          item.fechaFin = this.formatDateTime(item.fechaFin);
        });
        this.openModalAdditionalPromotor(enviado)
      }),
      catchError(error => {
        console.log(error)
        return of(this.toastr.error('Ocurrió un error el detalle de comisiones.'));
      })
    ).subscribe();
  }

  openModalAdditionalPromotor(enviado: number) {
    let modalRef = this.modalService.open(ModalCommissionDispositionComponent, { centered: true, size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.listCommissionDispositionDetail = this.listComisionDispositionDetail;
    modalRef.componentInstance.enviado = enviado;
    //console.error(enviado);
    modalRef.result.then(
      data => console.log(">> DATA: " + data),
      reason => {
        console.log(">> JSON CREDITO: " + JSON.stringify(reason));
        this.GetCommissionDisposition();
        this.view = 1;
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}